<form class="example-form ">

  <div class="simple-input">
    <input type="text" [placeholder]="placeholder" [formControl]="control" [matAutocomplete]="auto" (focus)="seeList()"
      [ngStyle]="{ 'height.px': height }" style="width: 100%;" [autofocus]="false">
  </div>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    <mat-option style="min-height: 20px; font-size: 12px;" *ngFor="let option of filteredOptions | async"
      [value]="option">
      {{ option.label }}
    </mat-option>
  </mat-autocomplete>
</form>
